import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal, Checkbox, Icon } from '@kdcloudjs/kdesign'
import "./checkModal.less"

const bodyStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0",
    overflow: "hidden"
}

function CheckModal(props) {
    const { resolve, reject, title, checkList, defaultValue, colNameStr, checkedStr, clearStr, sureStr, cancelStr } = props

    const [visible, setVisible] = useState(true)

    const [value, setValue] = useState(defaultValue || [])

    const checkMap = {}

    checkList.forEach(item => {
        checkMap[item.id] = item
    })

    const checkListlen = checkList.length

    const handleClick = (bool) => {
        setVisible(bool)

        reject(value)
    }

    const handleClickSure = (bool) => {
        setVisible(bool)

        resolve({
            fields: checkList.filter(item => {
                return value.indexOf(item.id + "") > -1
            }),
            ids: value
        })
    }

    const onChange = (value) => {
        console.log('checkboxgroup checked', value)
        setValue([...value])
    }

    const onChangeAll = (e) => {
        console.log('onChangeAll checked', e.target.checked)
        let newValue
        if (e.target.checked) {
            newValue = checkList.map(item => item.id)
        } else {
            newValue = []
        }
        console.log("onChangeAll", newValue);
        setValue(newValue)
    }

    const getIndeterminate = (value) => {
        return value.length > 0 && value.length < checkListlen
    }

    const delSelected = delId => {
        const newValue = value.filter(id => id !== delId)

        setValue(newValue)
    }

    const body = (
        <div className="modal-main">
            <div className="info">
                <ul className="title-list">
                    <li style={{ width: "30px" }} className="title-item">
                        <Checkbox checked={value.length === checkListlen} indeterminate={getIndeterminate(value)} onChange={onChangeAll} />
                    </li>
                    <li style={{ width: "30px" }} className="title-item">#</li>
                    <li style={{ width: "360px" }} className="title-item">{colNameStr}</li>
                    {/* <li style={{ width: "200px" }} className="title-item">卡片维度</li> */}
                </ul>
                <Checkbox.Group onChange={onChange} value={value} className="check-list" checkboxType={'default'}>
                    {
                        checkList.map((item, i) => {
                            return (
                                <Checkbox value={item.id} key={item.index}>
                                    <div className="check-info" key={item.index}>
                                        <ul className="info-list">
                                            <li style={{ width: "30px" }} className="info-item">{i + 1}</li>
                                            <li style={{ width: "360px" }} className="info-item">{item.name}</li>
                                            {/* <li style={{ width: "200px" }} className="info-item">{item.carddimensionName}</li> */}
                                        </ul>
                                    </div>
                                </Checkbox>
                            )
                        })
                    }
                </Checkbox.Group>
            </div>
            <div className="nav">
                <div className="head">
                    <div className="tip-info">
                        {checkedStr}（{value.length}）
                    </div>
                    <div className="op-selected" onClick={() => { setValue([]) }}>
                        {clearStr}
                    </div>
                </div>
                <div className="selected">
                    <ul>
                        {
                            value.map(id => {
                                return (
                                    <li className="selected-item" key={id}>
                                        <span>{checkMap[id].name}</span>
                                        <Icon className="icon" type="close" onClick={() => { delSelected(id) }} />
                                    </li>
                                )
                            })
                        }

                    </ul>
                </div>
            </div>
        </div>
    )

    return (
        <Modal
            body={body}
            bodyStyle={bodyStyle}
            width={960}
            height={580}
            title={<div style={{ fontSize: "16px" }}>{title}</div>}
            footer={
                <>
                    <Button style={{ margin: "0 6px" }} onClick={() => handleClickSure(false)} type="primary">{sureStr}</Button>
                    <Button style={{ margin: "0 6px" }} onClick={() => handleClick(false)} type="ghost" >{cancelStr}</Button>
                </>
            }
            onCancel={() => handleClick(false)}
            closable={true}
            mask={true}
            visible={visible}
            maskClosable={false}
            className="modal-container"
        />
    );
}

function makeCheckModal(props) {

    return new Promise((resolve, reject) => {
        const ConDiv = document.createElement('div');

        document.body.appendChild(ConDiv);

        ReactDOM.render(<CheckModal {...props} resolve={resolve} reject={reject} />, ConDiv);
    })

}

export default makeCheckModal;